import {RestaurantsActionTypes, RestaurantsAction} from './../actions/restaurants'


export interface RestaurantsState {
  restaurants: any[];
}

const initialState: RestaurantsState = {
  restaurants: [],
};

const restaurantsReducer = (state = initialState, action: RestaurantsAction) => {
  switch (action.type) {
    case RestaurantsActionTypes.SET_RESTAURANTS:
      return {
        ...state,
        restaurants: action.payload,
      };
    default:
      return state;
  }
};

export default restaurantsReducer;